module.exports = __webpack_public_path__ + "img/car_3_toyota.ed0aec4a.jpg";